import Vue from 'vue'
import DefaultLayout from '@/views/layouts/DefaultLayout'

Vue.component('default-layout', DefaultLayout)
